import { useIsMarqiiUser } from '@/hooks/permissions/useIsMarqiiUser'
import { CoreLevelFeatureNames } from '@/services/types/permissions/permissionFeatures/mockCorePermissionFeature'
import { PremiumFeatures } from '@/services/types/premiumFeatures/premiumFeatures'
import { useCorePermissions } from '@/stores/permissions/permissions'
import { usePremiumFeaturesPermissions } from '@/stores/permissions/premiumFeatures'
import { useMemo } from 'react'

export function useTemplateManagementPermissions() {
  const premiumFeatures = usePremiumFeaturesPermissions()
  const { isMarqiiUser } = useIsMarqiiUser()

  const templateManagementRnP = useCorePermissions(CoreLevelFeatureNames.templateManagement)

  const hasManagedReviewsInternalFeature = premiumFeatures.includes(
    PremiumFeatures.ManagedReviewsInternal,
  )
  const hasReviewMonitoringFeature = premiumFeatures.includes(PremiumFeatures.ReviewMonitoring)

  const hasEditTemplateManagementRole = useMemo(() => {
    return !!templateManagementRnP?.edit
  }, [templateManagementRnP])

  const hasTemplatesManagementPagePermission = useMemo(() => {
    return hasReviewMonitoringFeature && hasEditTemplateManagementRole
  }, [hasEditTemplateManagementRole, hasReviewMonitoringFeature])

  const shouldShowTemplatesManagement = useMemo(() => {
    return hasManagedReviewsInternalFeature
      ? hasTemplatesManagementPagePermission && isMarqiiUser
      : hasTemplatesManagementPagePermission
  }, [hasManagedReviewsInternalFeature, hasTemplatesManagementPagePermission, isMarqiiUser])

  return { shouldShowTemplatesManagement }
}
